import React, { useState } from 'react';
import { Box } from '@mui/material';
import DonorManagement from './DonorManagementPage';
import EmailSenderDialog from './EmailSenderDialog';

// This component now receives props from its parent
const EmailSender = ({ allDonors, campaigns, fetchAllDonors }) => {
    const [openDialog, setOpenDialog] = useState(false);
    const [donorsForCampaign, setDonorsForCampaign] = useState([]);
    const [selectedCampaignId, setSelectedCampaignId] = useState(null);

    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
        }}>
            <DonorManagement
                onOpenEmailDialog={handleOpenDialog}
                campaigns={campaigns}
                donors={donorsForCampaign}
                setDonors={setDonorsForCampaign}
                selectedCampaignId={selectedCampaignId}
                setSelectedCampaignId={setSelectedCampaignId}
            />

            <EmailSenderDialog
                open={openDialog}
                handleClose={handleCloseDialog}
                campaigns={campaigns}
                allDonors={allDonors}
                donorsForCampaign={donorsForCampaign}
                selectedCampaignId={selectedCampaignId}
                fetchAllDonors={fetchAllDonors}
            />
        </Box>
    );
};

export default EmailSender;